// @flow
import React, { type Node } from 'react';
import { compose, pure } from 'recompose';
import { hot } from 'react-hot-loader';
import { legacyAnalytics } from 'angieslist-app-platform';
import { get } from 'lodash';
import DownloadPrompt from '../../../app/browser/download/DownloadPrompt';
import welcomeDownloadAnalytics from './welcomeDownloadAnalytics';

type WelcomeDownloadViewProps = {
  params: { // eslint-disable-line react/no-unused-prop-types
    serviceProviderId: number,
  },
};

export const WelcomeDownloadViewComponent = (props: WelcomeDownloadViewProps): Node => {
  const serviceProviderId = get(props, 'params.serviceProviderId');
  return (
    <DownloadPrompt
      header="Download Our Pro Ads Mobile App"
      subheader="Our best Angi Pro Ads experience, designed with you in mind."
      showEscapeLink
      serviceProviderId={serviceProviderId}
      referrer="OfficeOnboardFunnel"
    />
  );
};

export default (hot(module)(compose(
  legacyAnalytics({
    ruleset: welcomeDownloadAnalytics,
  }),
  pure,
)(WelcomeDownloadViewComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/WelcomeDownloadView.js